export const useIsRecognize = () => {
	const urlOrigin = window.location.origin;
	const urlPath = window.location.pathname;

	const isMonarch =
		urlOrigin === 'https://app.bonus.ly' ||
		(urlOrigin === 'https://bonus.ly' && urlPath.startsWith('/app')) ||
		urlOrigin === 'https://app-staging.bonus.ly' ||
		(urlOrigin === 'https://staging.bonus.ly' && urlPath.startsWith('/app')) ||
		urlOrigin === 'http://localhost:3003';

	return !isMonarch;
};
